// src/utils/resolveTypography.js

export function resolveTypography(pageTypography, panelStyle) {
    const g = pageTypography || {};
    const p = panelStyle || {};

    const pick = (scope, keys) => {
        const base = g[scope] || {};
        const over = p[scope] || {};
        const o = {};
        keys.forEach(k => {
            if (over[k] !== undefined && over[k] !== '') o[k] = over[k];
            else if (base[k] !== undefined) o[k] = base[k];
        });
        return o;
    };

    return {
        headers: pick('headers', ['fontFamily','fontSize','fontWeight','color','lineHeight']),
        paragraph: pick('paragraph', ['fontFamily','fontSize','color','lineHeight']),
        links: pick('links', ['color','textDecoration']),
    };
}
